<template>
  <div class="pickup-point-selector">
    <el-tabs class="pickup-point-tab-selector" v-if="showStyle === 'tab' && warehouses.length" v-model="type" type="card">
      <el-tab-pane :label="$t('pickup_point_selector.pickups')" name="pickups" v-if="pickupZones.length">
        <el-tabs v-model="pickupZone" tab-position="left">
          <el-tab-pane :label="zone" :name="zone"
                       v-for="zone in pickupZones" :key="zone">
            <div class="row">
              <div class="col-md-4 col-sm-12" v-for="item in pickupFiltered" :key="item.id">
                <el-tooltip :content="item.address" placement="right">
                  <el-radio v-model="model" :label="item.id" border class="w-100" :disabled="disabled">
                    {{ item.name }}
             </el-radio>
                </el-tooltip>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
      <el-tab-pane :label="$t('pickup_point_selector.post_office')" name="post-office" v-if="postOfficeZones.length">
        <el-tabs v-model="postOfficeZone" tab-position="left">
          <el-tab-pane :label="zone" :name="zone"
                       v-for="zone in postOfficeZones" :key="zone">
            <div class="row">
              <div class="col-md-4 col-sm-12" v-for="item in postOfficeFiltered" :key="item.id">
                <el-tooltip :content="item.address" placement="right">
                  <el-radio v-model="model" :label="item.id" border class="w-100" :disabled="disabled">
                    {{ item.name }}
             </el-radio>
                </el-tooltip>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
	  <el-tab-pane :label="$t('pickup_point_selector.post_locker')" name="post-locker" v-if="postLockerZones.length">
        <el-tabs v-model="postLockerZone" tab-position="left">
          <el-tab-pane :label="zone" :name="zone"
                       v-for="zone in postLockerZones" :key="zone">
            <div class="row">
              <div class="col-md-4 col-sm-12" v-for="item in postLockerFiltered" :key="item.id">
                <el-tooltip :content="item.address" placement="right">
                  <el-radio v-model="model" :label="item.id" border class="w-100" :disabled="disabled">
                    {{ item.name }}
             </el-radio>
                </el-tooltip>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
	  <el-tab-pane :label="$t('pickup_point_selector.ok')" name="ok" v-if="okZones.length">
        <el-tabs v-model="okZone" tab-position="left">
          <el-tab-pane :label="zone" :name="zone"
                       v-for="zone in okZones" :key="zone">
            <div class="row">
              <div class="col-md-4 col-sm-12" v-for="item in okFiltered" :key="item.id">
                <el-tooltip :content="item.address" placement="right">
                  <el-radio v-model="model" :label="item.id" border class="w-100" :disabled="disabled">
                    {{ item.name }}
             </el-radio>
                </el-tooltip>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
	  <el-tab-pane :label="$t('pickup_point_selector.cainiao_locker')" name="cainiao-locker" v-if="cainiaoLockers.length">
        <el-tabs v-model="cainiaoLockerZone" tab-position="left">
          <el-tab-pane :label="zone" :name="zone"
                       v-for="zone in cainiaoLockerZones" :key="zone">
            <div class="row">
              <div class="col-md-4 col-sm-12" v-for="item in cainiaoLockerFiltered" :key="item.id">
                <el-tooltip :content="item.address" placement="right">
                  <el-radio v-model="model" :label="item.id" border class="w-100" :disabled="disabled">
                    {{ item.name }}
             </el-radio>
                </el-tooltip>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
    </el-tabs>
    <div class="pickup-point-cascader-selector" v-if="showStyle === 'cascader' && warehouses.length">
      <el-cascader
          class="w-100"
          v-model="cascaderSelected"
          :options="cascaderOptions"
          clearable
          @change="handleChange"
      ></el-cascader>
      <div class="mt-1" v-if="showAddress && address">
        <strong v-if="address">{{ $t('pickup_point_selector.address') }}:</strong>  {{ address }}
      </div>
    </div>
    <div v-if="!warehouses.length">{{ $t('app.loading') }}</div>
  </div>
</template>

<script>
  import _ from 'lodash';
  import { mapState, mapGetters } from 'vuex';
  import { Probability } from '@/plugins/helpers';

  export default {
    name: 'PickupPointSelector',
    model: {
      prop: 'value',
      event: 'change',
    },
    props: {
      value: {},
      disabled: {
        type: Boolean,
        default: false,
      },
      showStyle: {
        type: String,
        default: 'tab',
      },
      showAddress: {
        type: Boolean,
        default: true,
      },
    },
    mounted() {
      this.setDefaultZone();
      (new Probability({
        p: this.warehouses.length ? '30%' : '100%',
        f: () => this.fetchWarehouse(),
      }))();
    },
    data() {
      return {
        type: 'pickups',
        pickupZone: '',
        postOfficeZone: '',
		postLockerZone: '',
		okZone: '',
		cainiaoLockerZone: '',
        cascaderSelected: [],
        address: '',
      };
    },
    computed: {
      ...mapState({
        warehouses: state => state.warehouse.warehouses,
      }),
      ...mapGetters([
        'pickups',
        'postOffices',
		'postLockers',
		'oks',
		'cainiaoLockers',
      ]),
      model: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('change', val);
        },
      },
      pickupZones() {
        return _.map(_.uniqBy(this.pickups, 'zone_name'), 'zone_name');
      },
      postOfficeZones() {
        return _.map(_.uniqBy(this.postOffices, 'zone_name'), 'zone_name');
      },
	  postLockerZones() {
        return _.map(_.uniqBy(this.postLockers, 'zone_name'), 'zone_name');
      },
	  okZones() {
        return _.map(_.uniqBy(this.oks, 'zone_name'), 'zone_name');
      },
	  cainiaoLockerZones() {
        return _.map(_.uniqBy(this.cainiaoLockers, 'zone_name'), 'zone_name');
      },
      pickupFiltered() {
        return _.filter(this.pickups, { zone_name: this.pickupZone });
      },
      postOfficeFiltered() {
        return _.filter(this.postOffices, { zone_name: this.postOfficeZone });
      },
	  postLockerFiltered() {
        return _.filter(this.postLockers, { zone_name: this.postLockerZone });
      },
	  okFiltered() {
        return _.filter(this.oks, { zone_name: this.okZone });
      },
	  cainiaoLockerFiltered() {
        return _.filter(this.cainiaoLockers, { zone_name: this.cainiaoLockerZone });
      },
      cascaderOptions() {
		let arr = [];
		if(this.pickups.length) {
          let a = {
            label: this.$t('pickup_point_selector.pickups'),
            value: 'pickups',
            children: _.map(this.pickupZones, zone_name => (
            {
              label: zone_name,
              value: zone_name,
              children: _.map(_.filter(this.pickups, { zone_name }), item => (
                {
                  label: item.name,
                  value: item.id,
                }
              )),
            })),
          };
		  arr.push(a);
		}
		
		if(this.postOffices.length) {
          let a = {
            label: this.$t('pickup_point_selector.post_office'),
            value: 'post-office',
            children: _.map(this.postOfficeZones, zone_name => (
            {
              label: zone_name,
              value: zone_name,
              children: _.map(_.filter(this.postOffices, { zone_name }), item => (
                {
                  label: item.name,
                  value: item.id,
                }
              )),
            })),
          };
		  arr.push(a);
		}
		
		if(this.postLockers.length) {
          let a = {
            label: this.$t('pickup_point_selector.post_locker'),
            value: 'post-locker',
            children: _.map(this.postLockerZones, zone_name => (
            {
              label: zone_name,
              value: zone_name,
              children: _.map(_.filter(this.postLockers, { zone_name }), item => (
                {
                  label: item.name,
                  value: item.id,
                }
              )),
            })),
          };
		  arr.push(a);
		}
		
		if(this.oks.length) {
          let a = {
            label: this.$t('pickup_point_selector.ok'),
            value: 'ok',
            children: _.map(this.okZones, zone_name => (
            {
              label: zone_name,
              value: zone_name,
              children: _.map(_.filter(this.oks, { zone_name }), item => (
                {
                  label: item.name,
                  value: item.id,
                }
              )),
            })),
          };
		  arr.push(a);
		}
		
		if(this.cainiaoLockers.length) {
          let a = {
            label: this.$t('pickup_point_selector.cainiao_locker'),
            value: 'cainiao-locker',
            children: _.map(this.cainiaoLockerZones, zone_name => (
            {
              label: zone_name,
              value: zone_name,
              children: _.map(_.filter(this.cainiaoLockers, { zone_name }), item => (
                {
                  label: item.name,
                  value: item.id,
                }
              )),
            })),
          };
		  arr.push(a);
		}
        return arr;
      },
    },
    methods: {
      fetchWarehouse() {
        this.$store.dispatch('fetchWarehouse').then(() => {
          this.setDefaultZone();
        }).catch(() => {
          this.$notify({
            type: 'danger',
            title: this.$t('checkout.get_self_point_address_err'),
          });
        });
      },
      setDefaultZone() {
        /* eslint-disable prefer-destructuring */
        if (this.pickupZones.length && this.pickupZone === '0') {
          this.pickupZone = this.pickupZones[0];
        }
        if (this.postOfficeZones.length && this.postOfficeZone === '0') {
          this.postOfficeZone = this.postOfficeZones[0];
        }
		if (this.postLockerZones.length && this.postLockerZone === '0') {
          this.postLockerZone = this.postLockerZones[0];
        }
		if (this.okZones.length && this.okZone === '0') {
          this.okZone = this.okZones[0];
        }
		if (this.cainiaoLockerZones.length && this.cainiaoLockerZone === '0') {
          this.cainiaoLockerZone = this.cainiaoLockerZones[0];
        }
      },
      handleChange(val) {
        if (val.length) {
          // eslint-disable-next-line
          const [type, zone, id] = val;
          if (type === 'pickups') {
            const pickup = _.find(this.pickups, { id });
            this.address = pickup.address;
          }
          if (type === 'post-office') {
            const pickup = _.find(this.postOffices, { id });
            this.address = pickup.address;
          }
		  if (type === 'post-locker') {
            const pickup = _.find(this.postLockers, { id });
            this.address = pickup.address;
          }
		  if (type === 'ok') {
            const pickup = _.find(this.oks, { id });
            this.address = pickup.address;
          }
		  if (type === 'cainiao-locker') {
            const pickup = _.find(this.cainiaoLockers, { id });
            this.address = pickup.address;
          }
          this.model = id;
        } else {
          this.model = null;
          this.address = '';
        }
      },
    },
  };
</script>

<style lang="scss">
  .pickup-point-tab-selector {
    //
  }
</style>
